module.exports = "<div data-edit-notification-configuration></div>\n"